import {DrawerProps} from '@mantine/core';
import {useParams} from 'react-router-dom';
import {FormDrawer} from './FormDrawer.tsx';
import {useTestingAction} from '../hooks/useTestingAction.ts';

export const EditFormDrawer = (props: DrawerProps) => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useTestingAction(id);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    );
};
